import { Request as JSONRequest } from "../helpers/request";

// the token list is cached by the CDN, the hourly bucket refreshes it at most once per hour
const ONE_HOUR = 60 * 60 * 1000;
const cacheBucket = () => Math.floor(Date.now() / ONE_HOUR);

// one request per list and session
const requests = {};

class Tokens extends JSONRequest {
  constructor() {
    super({ url: import.meta.env.VITE_TOKEN_API });
  }
  getList(name) {
    if (!requests[name]) {
      requests[name] = this.getPrepared(`/${name}.json`, { timestamp: cacheBucket() }).catch((error) => {
        delete requests[name];
        throw error;
      });
    }
    return requests[name];
  }
  getMainnet() {
    return this.getList("mainnet");
  }
  getTestnetv4() {
    return this.getList("testnetv4");
  }
  getHarbinger() {
    return this.getList("harbinger");
  }
}

export default Tokens;
